module.exports = __webpack_public_path__ + "b84f555f87ba5a3485c1f2136cfb2d0f.svg";